import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../api';

interface Sub {
  _id: string;
  userId: string;
  plan: string;
  status: string;
  currentPeriodEnd: string;
  price: number;
  attributedAffiliateCode?: string;
}

export default function Subscriptions() {
  const [status, setStatus] = useState('active');
  const { data } = useQuery<{ items: Sub[] }>({
    queryKey: ['admin', 'subs', status],
    queryFn: () => api(`/api/v1/admin/subscriptions?status=${status}`),
  });
  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">Subscriptions</h1>
        <select
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          className="bg-surface border border-border rounded-md px-3 py-2"
        >
          {['active', 'past_due', 'canceled', 'trialing'].map((s) => (
            <option key={s}>{s}</option>
          ))}
        </select>
      </div>
      <div className="bg-surface border border-border rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-surface2 text-left text-text2">
            <tr>
              <th className="px-4 py-3">User</th>
              <th className="px-4 py-3">Plan</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3">Renews</th>
              <th className="px-4 py-3">Affiliate</th>
              <th className="px-4 py-3 text-right">Price</th>
            </tr>
          </thead>
          <tbody>
            {(data?.items ?? []).map((s) => (
              <tr key={s._id} className="border-t border-border">
                <td className="px-4 py-3 font-mono text-xs">{s.userId}</td>
                <td className="px-4 py-3">{s.plan}</td>
                <td className="px-4 py-3">{s.status}</td>
                <td className="px-4 py-3">{new Date(s.currentPeriodEnd).toLocaleDateString()}</td>
                <td className="px-4 py-3 font-mono text-xs text-accent">{s.attributedAffiliateCode ?? '–'}</td>
                <td className="px-4 py-3 text-right">${s.price}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
